import React from 'react';
import moment from 'moment';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import {
  fetchVehicleMaintenance as _fetchVehicleMaintenance,
  updateVehicleMaintenance as _updateVehicleMaintenance,
  deleteVehicleMaintenance as _deleteVehicleMaintenance,
  createMaintenanceImage as _createMaintenanceImage,
  deleteMaintenanceImage as _deleteMaintenanceImage,
  checkManufacturerServiceBook as _checkManufacturerServiceBook,
} from '../../../actions/vehicleActions';
import InfoboxWithIcon from './ListItems/InfoboxWithIcon';
import MaintenanceTaskListItem from './ListItems/MaintenanceTaskListItem';
import MaintenancePartListItem from './ListItems/MaintenancePartListItem';
import CBMediaQuery from '../../shared/CBMediaQuery';
import { getStyle, styleMerge, formatKm, SERVICE_FLEET, SERVICE_WORKSHOP, SERVICE_CHAIN, formatDateTime, formatDate, SERVICE_PERSONAL, getCurrentCompany } from '../../../utils/utils';
import CBSpinner from '../../shared/CBSpinner';
import TextWithLineBreaks from '../../shared/TextWithLinebreaks';
import AddMaintenanceModal from './AddMaintenanceModal';
import CBPromptModal from '../../shared/CBPromptModal';
import ImageCarouselModal from './ImageCarouselModal';
import CBDropzone from '../../shared/CBDropzone';
import AddImageModal from '../../shared/AddImageModal';
import CBButtonGarageAction from '../../shared/CBButtonGarageAction';
import SetLastPeriodicMaintenanceModal from './Modal/SetLastPeriodicMaintenanceModal';
import ManufacturerServiceBookEntryModal from './ManufacturerServiceBookEntryModal';
import CBLabelAndValue from '../../shared/CBLabelAndValue';
import CBButtonWithIconSmall from '../../shared/CBButtonWithIconSmall';

class VehicleDetailsMaintenanceContent extends React.Component {
  state = {
    modalIsOpen: false,
    deleteModalIsOpen: false,
    imageModalIsOpen: false,
    removingImages: false,
    lastPeriodicMaintenanceModalIsOpen: false,
    manufacturerServiceBookEntryModalIsOpen: false,
    imageIndex: 0,
    oeApiKeyExpired: false,
  };

  getChainParams = () => {
    const { selectedChainId, service } = this.props;
    if (service === SERVICE_CHAIN && selectedChainId) {
      return { chain_id: selectedChainId };
    }
    return undefined;
  };

  componentDidMount = () => {
    const {
      match, fetchVehicleMaintenance, vehicle, searchRequest, selectedWorkshopId, service, user
    } = this.props;
    const { maintenanceIDs } = searchRequest;
    const chainParams = this.getChainParams();
    if (match) {
      fetchVehicleMaintenance(match.params.maintenanceId, chainParams);
    } else if (vehicle && vehicle.maintenances.length) {
      if (maintenanceIDs) {
        if (maintenanceIDs.length) {
          fetchVehicleMaintenance(maintenanceIDs[0], chainParams);
        }
      } else {
        fetchVehicleMaintenance(vehicle.maintenances[0].id, chainParams);
      }
    }
    const currentWorkshop = getCurrentCompany(user, null, selectedWorkshopId, null);

    const manufacturerServiceBookEnabled = currentWorkshop && currentWorkshop.feature_manufacturer_service_book;
    if (selectedWorkshopId && service === SERVICE_WORKSHOP && manufacturerServiceBookEnabled) {
      this.fetchOEAuthenticationStatus();
    }
  };

  handleOEAuth = () => {
    window.location.href = `/api/1/integrations/oe/login/${this.props.selectedWorkshopId}/`;
  };

  fetchOEAuthenticationStatus = async () => {
    const { selectedWorkshopId } = this.props;
    if (!selectedWorkshopId) return;

    try {
      const response = await fetch(`/api/1/integrations/oe/is-authentication-expired/?workshop_id=${selectedWorkshopId}`, {
        credentials: 'same-origin',
      });
      if (!response.ok) return;
      const data = await response.json();
      this.setState({ oeApiKeyExpired: !!data.authentication_expired });
    } catch (e) {
      // Swallow errors and keep default false
    }
  };

  componentDidUpdate(prevProps) {
    const {
      match, fetchVehicleMaintenance, vehicle, searchRequest,
    } = this.props;
    const { maintenanceIDs } = searchRequest;
    const chainParams = this.getChainParams();

    if (match && match.params.maintenanceId !== prevProps.match.params.maintenanceId) {
      fetchVehicleMaintenance(match.params.maintenanceId, chainParams);
    } else if (
      vehicle
      && vehicle.maintenances.length
      && vehicle.maintenances[0].complete !== prevProps.vehicle.maintenances[0].complete
    ) {
      if (maintenanceIDs) {
        if (maintenanceIDs.length) {
          fetchVehicleMaintenance(maintenanceIDs[0], chainParams);
        }
      } else {
        fetchVehicleMaintenance(vehicle.maintenances[0].id, chainParams);
      }
    } else if (
      vehicle
      && vehicle.maintenances.length
      && maintenanceIDs
      && maintenanceIDs.length
      && prevProps.searchRequest
      && prevProps.searchRequest.maintenanceIDs
      && maintenanceIDs[0] !== prevProps.searchRequest.maintenanceIDs[0]) {
      fetchVehicleMaintenance(maintenanceIDs[0], chainParams);
    }
  }

  deleteVehicleMaintenance = () => {
    const { deleteVehicleMaintenance, match, vehicle } = this.props;
    this.setState({
      deleteModalIsOpen: false,
    });
    if (match) {
      deleteVehicleMaintenance(match.params.maintenanceId);
    } else if (vehicle && vehicle.maintenances.length) {
      deleteVehicleMaintenance(vehicle.maintenances[0].id);
    }
  }

  openDeleteMaintenanceModal = () => {
    this.setState({
      deleteModalIsOpen: true,
    });
  };

  closeDeleteModal = () => {
    this.setState({
      deleteModalIsOpen: false,
    });
  };

  editMaintenance = () => {
    this.setState({
      modalIsOpen: true,
    });
  };

  closeModal = () => {
    this.setState({
      modalIsOpen: false,
    });
  };

  hideAddImageModal = () => {
    this.setState({
      addImageModal: false,
    });
  }

  onImageUpload = acceptedFiles => {
    acceptedFiles.forEach(file => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.setState({
          addedImage: reader.result,
          addImageModal: true,
        });
      };
    });
  };

  uploadImage = (image, maintenanceId) => {
    const { createMaintenanceImage } = this.props;
    this.setState({ addImageModal: false });
    if (maintenanceId) {
      createMaintenanceImage({
        maintenance: maintenanceId,
        image: image
      });
    }
  }

  toggleImageRemoveMode = () => {
    this.setState(prevState => ({
      ...prevState,
      removingImages: !prevState.removingImages,
    }));
  }

  removeImage = id => {
    const { deleteMaintenanceImage } = this.props;
    deleteMaintenanceImage(id);
  }

  openImageModal = index => {
    this.setState({ imageModalIsOpen: true, imageIndex: index });
  }

  hideImageModal = () => {
    this.setState({ imageModalIsOpen: false });
  }

  render() {
    const {
      vehicleRequest, t, match, vehicle, searchRequest, user, selectedWorkshopId, service, checkManufacturerServiceBook
    } = this.props;

    const isContentEmpty = (content) => {
      if (!content) return true;
      return content.trim().length === 0;
    };

    const { maintenanceIDs } = searchRequest;
    const {
      modalIsOpen,
      deleteModalIsOpen,
      imageModalIsOpen,
      removingImages,
      imageIndex,
      addImageModal,
      addedImage,
      lastPeriodicMaintenanceModalIsOpen,
      manufacturerServiceBookEntryModalIsOpen,
      oeApiKeyExpired
    } = this.state;
    let maintenance = match && vehicle.maintenances
      ? vehicle.maintenances.find(
        x => x.id === parseInt(match.params.maintenanceId, 10),
      )
      : undefined;
    if (!maintenance && vehicle && vehicle.maintenances && vehicle.maintenances.length) {
      if (maintenanceIDs) {
        if (maintenanceIDs.length) {
          maintenance = vehicle.maintenances.find(
            x => x.id === parseInt(maintenanceIDs[0], 10),
          );
        }
      }
    }
    if (!maintenance) {
      return (
        <CBMediaQuery>
          {screenSize => (
            <div
              style={getStyle(screenSize, styles, 'maintenanceContentContainer')}
            />
          )}
        </CBMediaQuery>
      );
    }
    const currentOrganization = service === SERVICE_FLEET ? getCurrentCompany(user, vehicle.organization_id, null, null) : null;
    const isFleetEditable = (
      vehicle.can_edit
      && service === SERVICE_FLEET
      && maintenance
      && maintenance.source === 'organization'
      && currentOrganization
      && maintenance.organization === currentOrganization.id
    );
    const isWorkshopEditable = (
      vehicle.can_edit
      && service === SERVICE_WORKSHOP
      && maintenance
      && maintenance.source === 'carbook'
      && maintenance.workshop
      && maintenance.workshop.id == selectedWorkshopId
    );
    const editable = isFleetEditable || isWorkshopEditable;
    if (vehicleRequest.maintenanceStatus.loading || (maintenance && !maintenance.complete)) {
      return (
        <CBMediaQuery>
          {screenSize => (
            <div
              style={getStyle(screenSize, styles, 'maintenanceContentContainer')}
            >
              <CBSpinner />
            </div>
          )}
        </CBMediaQuery>
      );
    } else {
      let sourceCapitalized = '';
      if (maintenance) {
        switch (maintenance.source) {
          case 'carbook':
            sourceCapitalized = t('enteredInOvio');
            break;
          case 'organization':
            sourceCapitalized = (maintenance.organization_name || t('organizationSource')) + ' (' + t('enteredInOvio') + ')';
            break;
          default:
            sourceCapitalized = maintenance.source.charAt(0).toUpperCase()
              + maintenance.source.slice(1);
            break;
        }
      }

      const manufacturerServiceBookAvailable = maintenance.workshop && vehicle.manufacturer_service_books &&
          vehicle.manufacturer_service_books.some(msb =>
              msb.workshop.id === maintenance.workshop.id &&
              msb.has_dsb &&
              moment().diff(moment(maintenance.pickup_date), 'days') <= msb.max_age_in_days
          );

      const currentWorkshop = getCurrentCompany(user, null, selectedWorkshopId, null);

      const manufacturerServiceBookEnabled = currentWorkshop && currentWorkshop.feature_manufacturer_service_book;

      return (
        <CBMediaQuery>
          {screenSize => (
            <div
              style={getStyle(screenSize, styles, 'maintenanceContentContainer')}
            >
              {maintenance && (
                <React.Fragment>
                  <div style={getStyle(screenSize, styles, 'topInfoContainer')}>
                    <InfoboxWithIcon
                      icon='/img/icon_calendar.svg'
                      text={moment(maintenance.pickup_date).format('D.M.Y')}
                      labelText={t('dateInfobox')}
                      border='right'
                    />
                    <InfoboxWithIcon
                      icon='/img/icon_distance_1.svg'
                      text={`${formatKm(maintenance.km)}`}
                      labelText={t('kilometersInfobox')}
                      hasBorders
                    />
                    <InfoboxWithIcon
                      icon='/img/icon_13-1.svg'
                      text={maintenance.workshop ? maintenance.workshop.name : (maintenance.organization_name || '-')}
                      labelText={maintenance.workshop ? t('workshopInfobox') : t('organizationSource')}
                      border='left'
                      style={{ default: { infoboxContainer: { borderLeft: '1px solid rgba(255, 255, 255, .4)' } } }}
                    />
                  </div>
                  <div style={getStyle(screenSize, styles, 'bodyContainer')}>
                    <div
                      style={getStyle(screenSize, styles, 'tasksAndPartsContainer')}
                    >
                      <div
                        style={getStyle(screenSize, styles, 'taskContainer')}
                      >
                        <div style={getStyle(screenSize, styles, 'paddedContent')}>
                          <p
                            className='font-titillium-web-extra-light'
                            style={getStyle(screenSize, styles, 'sectionHeadingText')}
                          >
                            {t('maintenanceInfoHeading')}
                          </p>
                        </div>
                        {maintenance.tasks.map(task => (
                          <MaintenanceTaskListItem key={task.id} task={task} />
                        ))}
                      </div>
                      {maintenance.parts.length > 0 && (
                        <div
                          style={getStyle(screenSize, styles, 'partContainer')}
                        >
                          <div style={getStyle(screenSize, styles, 'paddedContent')}>
                            <p
                              className='font-titillium-web-extra-light'
                              style={getStyle(screenSize, styles, 'sectionHeadingText')}
                            >
                              {t('partsHeading')}
                            </p>
                          </div>
                            {maintenance.parts.map(part => (
                              <MaintenancePartListItem key={part.id} part={part} service={service} />
                            ))}
                        </div>
                      )}
                    </div>
                    {service === SERVICE_CHAIN && maintenance.chain_parts_analysis && (
                      <div style={chainAnalysisStyles.container}>
                        <p
                          className='font-titillium-web-extra-light'
                          style={getStyle(screenSize, styles, 'sectionHeadingText')}
                        >
                          {t('chainPartsAnalysisHeading')}
                        </p>
                        <div style={chainAnalysisStyles.statsRow}>
                          <div style={chainAnalysisStyles.statItem}>
                            <p style={chainAnalysisStyles.statLabel}>{t('chainPartsLabel')}</p>
                            <p style={chainAnalysisStyles.statValue}>
                              {Number(maintenance.chain_parts_analysis.chain_parts_price).toLocaleString('fi-FI', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                              {' \u20AC'}
                            </p>
                            <p style={chainAnalysisStyles.statCount}>
                              {maintenance.chain_parts_analysis.chain_parts_count} {t('pcsLabel')}
                            </p>
                          </div>
                          <div style={chainAnalysisStyles.statItem}>
                            <p style={chainAnalysisStyles.statLabel}>{t('otherPartsLabel')}</p>
                            <p style={chainAnalysisStyles.statValue}>
                              {Number(maintenance.chain_parts_analysis.other_parts_price).toLocaleString('fi-FI', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                              {' \u20AC'}
                            </p>
                            <p style={chainAnalysisStyles.statCount}>
                              {maintenance.chain_parts_analysis.other_parts_count} {t('pcsLabel')}
                            </p>
                          </div>
                          <div style={chainAnalysisStyles.statItem}>
                            <p style={chainAnalysisStyles.statLabel}>{t('totalLabel')}</p>
                            <p style={chainAnalysisStyles.statValue}>
                              {Number(maintenance.chain_parts_analysis.total_parts_price).toLocaleString('fi-FI', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                              {' \u20AC'}
                            </p>
                            <p style={chainAnalysisStyles.statCount}>
                              {maintenance.chain_parts_analysis.total_parts_count} {t('pcsLabel')}
                            </p>
                          </div>
                          <div style={chainAnalysisStyles.statItem}>
                            <p style={chainAnalysisStyles.statLabel}>{t('chainPartsShareLabel')}</p>
                            <p style={{
                              ...chainAnalysisStyles.percentageValue,
                              color: Number(maintenance.chain_parts_analysis.chain_parts_percentage) >= 80
                                ? '#4CAF50'
                                : Number(maintenance.chain_parts_analysis.chain_parts_percentage) >= 50
                                  ? '#FF9800'
                                  : '#F44336',
                            }}>
                              {Number(maintenance.chain_parts_analysis.chain_parts_percentage).toFixed(1)} %
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                    {
                      service !== SERVICE_PERSONAL && (
                        <div style={getStyle(screenSize, styles, 'additionalInfoContainer')}>
                          <p
                            className='font-titillium-web-extra-light'
                            style={getStyle(screenSize, styles, 'sectionHeadingText')}
                          >
                            {t('maintenanceAdditionalInfoHeading')}
                          </p>
                          {maintenance.notes.map(note => (
                            <div key={note.id}>
                              {!isContentEmpty(note.description) && (
                                <CBLabelAndValue label={t('maintenanceNoteDescription')} value={note.description} />
                              )}
                              {!isContentEmpty(note.description_customer) && (
                                <CBLabelAndValue label={t('maintenanceNoteDescriptionCustomer')} value={note.description_customer} useTextWithLineBreaks />
                              )}
                            </div>
                          ))}
                        </div>
                      )
                    }

                    {/* Hide because of GDPR */}
                    {/* {maintenance.foreman_name !== '' && (
                      <div style={getStyle(screenSize, styles, 'additionalInfoContainer')}>
                        <p
                          className='font-titillium-web-extra-light'
                          style={getStyle(screenSize, styles, 'sectionHeadingText')}
                        >
                          {t('foreman', { ns: 'ManufacturerServiceBook' })}
                        </p>
                        <p>{maintenance.foreman_name}</p>
                      </div>
                    )} */}
                    {maintenance.workshop && (
                    <div style={getStyle(screenSize, styles, 'workshopAddressContainer')}>
                      <p
                        className='font-titillium-web-extra-light'
                        style={getStyle(screenSize, styles, 'sectionHeadingText')}
                      >
                        {t('workshopAddressHeading')}
                      </p>
                      <p>
                        {`${maintenance.workshop.street_address}, ${
                          maintenance.workshop.zip_code
                        } ${maintenance.workshop.city}`}
                      </p>
                    </div>
                    )}
                  </div>

                  {maintenance.images.length > 0 && (
                    <div style={getStyle(screenSize, styles, 'imageContainer')}>
                      {maintenance.images.map((image, index) => (
                        <div
                          style={{
                            ...getStyle(screenSize, styles, 'squareImage'),
                            backgroundImage: `url(${image.image})`,
                          }}
                          key={image.id}
                          onClick={
                            removingImages
                              ? () => {
                                this.removeImage(image.id);
                                if (maintenance.images.length === 1) {
                                  this.setState({ removingImages: false });
                                }
                              }
                              : () => this.openImageModal(index)
                          }
                        >
                          {removingImages && <img style={getStyle(screenSize, styles, 'imageRemoveIcon')} src='/img/icon_trashcan.svg' alt={t('removeImg')} />}
                        </div>
                      ))}
                      <ImageCarouselModal
                        show={imageModalIsOpen}
                        handleClose={this.hideImageModal}
                        imageIndex={imageIndex}
                        images={maintenance.images}
                        showNextImage={this.showNextImage}
                        showPreviousImage={this.showPreviousImage}
                        getBackroundImageUrl={this.getBackroundImageUrl}
                      />
                    </div>
                  )}
                  <div style={getStyle(screenSize, styles, 'source')}>
                    {t('maintenanceSourceLabel')}
                    {': '}
                    {sourceCapitalized}
                  </div>
                  {
                    maintenance.is_last_periodic_maintenance && (
                      <div style={getStyle(screenSize, styles, 'lastPeriodicMaintenanceInfo')}>
                        <img
                          src="/img/icon_periodic_maintenance.png"
                          alt={t('previousPeriodicMaintenance')}
                          style={getStyle(screenSize, styles, 'lastPeriodicMaintenanceIcon')}
                        />
                        <p style={getStyle(screenSize, styles, 'lastPeriodicMaintenanceText')}>
                          {t('markedAsPreviousPeriodicMaintenance')}
                        </p>
                      </div>
                    )
                  }
                  {
                    !maintenance.is_vin_confirmed && (
                      <div style={getStyle(screenSize, styles, 'notVinConfirmedContainer')}>
                        <img style={getStyle(screenSize, styles, 'notVinConfirmedImg')} src='/img/icon_attention_red.svg' />
                        <p style={getStyle(screenSize, styles, 'notVinConfirmedText')}>{t('notVinConfirmed')}</p>
                      </div>
                    )
                  }

                  {
                    maintenance.workshop && manufacturerServiceBookEnabled && selectedWorkshopId == maintenance.workshop.id && (
                      <div style={getStyle(screenSize, styles, 'manufacturerServiceBookContainer')}>
                        <p className='font-titillium-web-extra-light' style={getStyle(screenSize, styles, 'sectionHeadingText')}>
                          {t('manufacturerServiceBookHeading')}
                        </p>
                        {
                          oeApiKeyExpired && (
                            <div style={getStyle(screenSize, styles, 'expiredApiKeyContainer')}>
                              <p style={getStyle(screenSize, styles, 'expiredApiKeyText')}>
                                {t('expiredApiKey', {ns: 'ManufacturerServiceBookLayoutView'})}
                              </p>
                              <div>
                                <CBButtonWithIconSmall
                                  text={t('authenticateWithOE', {ns: 'WSSettingsView'})}
                                  onClick={this.handleOEAuth}
                                />
                              </div>
                            </div>
                          )
                        }
                        <div style={getStyle(screenSize, styles, 'manufacturerServiceBookDataContainer')}>
                          <div style={getStyle(screenSize, styles, 'manufacturerServiceBookDataSideContainer')}>
                            {
                              !maintenance.manufacturer_service_book_entry && (
                                <React.Fragment>
                                  <CBLabelAndValue label={t('manufacturerServiceBookStatus')} value={t('availabilityNotChecked')} />
                                </React.Fragment>
                              )
                            }
                            {
                              maintenance.manufacturer_service_book_entry && maintenance.manufacturer_service_book_entry.is_available && maintenance.manufacturer_service_book_entry.status == 'available' && (
                                <React.Fragment>
                                  <CBLabelAndValue label={t('manufacturerServiceBookStatus')} value={t('msbStatusAvailable')} />
                                  <CBLabelAndValue label={t('manufacturerServiceBookStatusExpiresAt')} value={formatDate(maintenance.manufacturer_service_book_entry.expires_at)} />
                                </React.Fragment>
                              )
                            }
                            {
                              maintenance.manufacturer_service_book_entry && maintenance.manufacturer_service_book_entry.status == 'not_available' && (
                                <React.Fragment>
                                  <CBLabelAndValue label={t('manufacturerServiceBookStatus')} value={t('msbStatusNotAvailable')} />
                                </React.Fragment>
                              )
                            }
                            {
                              maintenance.manufacturer_service_book_entry &&maintenance.manufacturer_service_book_entry.status == 'expired' && (
                                <React.Fragment>
                                  <CBLabelAndValue label={t('manufacturerServiceBookStatus')} value={t('msbStatusExpired')} />
                                </React.Fragment>
                              )
                            }
                            {
                              maintenance.manufacturer_service_book_entry && !!maintenance.manufacturer_service_book_entry.external_status_display && (
                                <React.Fragment>
                                  <CBLabelAndValue label={t('manufacturerServiceBookStatus')} value={maintenance.manufacturer_service_book_entry.external_status_display} />
                                  <CBLabelAndValue label={t('manufacturerServiceBookStatusReason')} value={maintenance.manufacturer_service_book_entry.external_status_reason_display} />
                                </React.Fragment>
                              )
                            }

                          </div>
                          <div style={getStyle(screenSize, styles, 'manufacturerServiceBookDataSideContainer')}>
                            {maintenance.manufacturer_service_book_entry && maintenance.manufacturer_service_book_entry.last_webhook_timestamp && (
                              <CBLabelAndValue label={t('manufacturerServiceBookStatusTimestamp')} value={formatDateTime(maintenance.manufacturer_service_book_entry.last_webhook_timestamp)} />
                            )}
                          </div>
                        </div>
                      </div>
                    )
                  }

                  <div style={getStyle(screenSize, styles, 'boxContainer')}>
                    <div style={getStyle(screenSize, styles, 'boxLeftContainer')}>
                    </div>
                    <div style={getStyle(screenSize, styles, 'boxRightContainer')}>
                      {
                        vehicle.organization_data && (!!vehicle.organization_data.maintenance_interval_months
                        || !!vehicle.organization_data.maintenance_interval_km) && vehicle.can_edit
                        && (service === SERVICE_FLEET || service === SERVICE_WORKSHOP)
                        && !maintenance.is_last_periodic_maintenance && (
                          <CBButtonGarageAction
                            mainIcon='/img/icon_car_service.svg'
                            text={t('setAsPreviousMaintenance')}
                            onClick={() => { this.setState({lastPeriodicMaintenanceModalIsOpen: true}) }}
                            additionalStylesMainIcon={{ height: 25, width: 25 }}
                          />
                        )
                      }
                      {
                        service === SERVICE_WORKSHOP &&
                        maintenance.manufacturer_service_book_entry &&
                        maintenance.manufacturer_service_book_entry.is_available &&
                        maintenance.workshop && selectedWorkshopId == maintenance.workshop.id &&
                        maintenance.manufacturer_service_book_entry.status == 'available' &&
                        (
                          <CBButtonGarageAction
                            mainIcon='/img/icon_car_service.svg'
                            text={t('fillManufacturerServiceBook')}
                            disabled={oeApiKeyExpired}
                            onClick={() => { this.setState({manufacturerServiceBookEntryModalIsOpen: true}) }}
                            additionalStylesMainIcon={{ height: 25, width: 25 }}
                          />
                        )
                      }
                      {
                        maintenance.workshop && manufacturerServiceBookEnabled && selectedWorkshopId == maintenance.workshop.id && !maintenance.manufacturer_service_book_entry &&
                        (
                          <CBButtonGarageAction
                            mainIcon='/img/icon_car_service.svg'
                            text={t('checkManufacturerServiceBookAvailability')}
                            disabled={oeApiKeyExpired}
                            onClick={() => { checkManufacturerServiceBook(maintenance.id) }}
                            additionalStylesMainIcon={{ height: 25, width: 25 }}
                          />
                        )
                      }
                      {
                        service === SERVICE_WORKSHOP &&
                        maintenance.workshop && selectedWorkshopId == maintenance.workshop.id &&
                        maintenance.manufacturer_service_book_entry &&
                        (maintenance.manufacturer_service_book_entry.document_url || maintenance.manufacturer_service_book_entry.url) && (
                          <CBButtonGarageAction
                            mainIcon='/img/icon_car_service.svg'
                            text={maintenance.manufacturer_service_book_entry.document_url ? t('downloadMsbEntry') : t('viewMsbEntry')}
                            onClick={() => {
                              const url = maintenance.manufacturer_service_book_entry.document_url || maintenance.manufacturer_service_book_entry.url;
                              window.open(url, '_blank');
                            }}
                            additionalStylesMainIcon={{ height: 25, width: 25 }}
                          />
                        )
                      }
                    </div>
                  </div>

                  {
                    editable && (
                      <div
                        className='font-titillium-web'
                        style={getStyle(screenSize, styles, 'boxContainer')}
                      >
                        <div
                          className='font-titillium-web'
                          style={getStyle(screenSize, styles, 'boxRightContainer')}
                        ></div>
                        <div
                          className='font-titillium-web'
                          style={getStyle(screenSize, styles, 'boxRightContainer')}
                        >
                          <div
                            className={removingImages ? '' : 'opacity-and-border-on-hover'}
                            style={removingImages ? {
                              ...getStyle(screenSize, styles, 'buttonLeft'),
                              ...getStyle(screenSize, styles, 'buttonDisabled'),
                            } : getStyle(screenSize, styles, 'buttonLeft')}
                            onClick={removingImages ? undefined : this.editMaintenance}
                          >
                            <img
                              style={getStyle(screenSize, styles, 'buttonIcon')}
                              alt='edit'
                              src='/img/edit.svg'
                            />
                            <div style={getStyle(screenSize, styles, 'buttonText')}>
                              {`${t('edit')} `}
                            </div>
                          </div>
                          <div
                            className={removingImages ? '' : 'opacity-and-border-on-hover'}
                            style={removingImages ? {
                              ...getStyle(screenSize, styles, 'button'),
                              ...getStyle(screenSize, styles, 'buttonDisabled'),
                            } : getStyle(screenSize, styles, 'button')}
                            onClick={removingImages ? undefined : this.openDeleteMaintenanceModal}
                          >
                            <img
                              style={getStyle(screenSize, styles, 'buttonIcon')}
                              alt='remove'
                              src='/img/remove.svg'
                            />
                            <div style={getStyle(screenSize, styles, 'buttonText')}>
                              {`${t('remove')} `}
                            </div>
                          </div>
                        </div>
                        {modalIsOpen && (
                        <AddMaintenanceModal
                          modalIsOpen={modalIsOpen}
                          closeModal={this.closeModal}
                          maintenance={maintenance}
                        />
                        )}
                        <CBPromptModal
                          modalIsOpen={deleteModalIsOpen}
                          closeModal={this.closeDeleteModal}
                          title={t('deleteMaintenancePromptTitle')}
                          text={t('deleteMaintenancePromptText')}
                          buttonText={t('deleteMaintenancePromptButton')}
                          performAction={this.deleteVehicleMaintenance}
                        />
                      </div>
                    )
                  }
                  {addImageModal && (
                    <AddImageModal
                      show={addImageModal}
                      handleClose={this.hideAddImageModal}
                      image={addedImage}
                      onImageSave={(image) => { this.uploadImage(image, maintenance.id); }}
                    />
                  )}
                  {
                    lastPeriodicMaintenanceModalIsOpen && maintenance && (
                      <SetLastPeriodicMaintenanceModal
                        modalIsOpen={lastPeriodicMaintenanceModalIsOpen}
                        closeModal={() => this.setState({lastPeriodicMaintenanceModalIsOpen: false})}
                        vehicle={vehicle}
                        maintenance={maintenance}
                      />
                    )
                  }
                  {
                    manufacturerServiceBookEntryModalIsOpen && maintenance && (
                      <ManufacturerServiceBookEntryModal
                        modalIsOpen={manufacturerServiceBookEntryModalIsOpen}
                        closeModal={() => this.setState({manufacturerServiceBookEntryModalIsOpen: false})}
                        vehicle={vehicle}
                        maintenance={maintenance}
                        workshop={maintenance.workshop}
                        manufacturerServiceBookEntry={maintenance.manufacturer_service_book_entry}
                        user={user}
                      />
                    )
                  }
                </React.Fragment>
              )}
            </div>
          )}
        </CBMediaQuery>
      );
    }
  }
}

const styles = {
  default: {
    manufacturerServiceBookContainer: {
      padding: 16,
    },
    manufacturerServiceBookDataContainer: {
      display: 'flex',
      flexDirection: 'row',
    },
    manufacturerServiceBookDataSideContainer: {
      flex: 1,
    },
    sectionHeadingText: {
      fontSize: 24,
    },
    paddedContent: {
      paddingLeft: 16,
      paddingTop: 16,
    },
    additionalInfoContainer: {
      padding: 16,
    },
    workshopAddressContainer: {
      padding: 16,
    },
    notVinConfirmedContainer: {
      padding: 16,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    notVinConfirmedImg: {
      height: 35,
      width: 35,
    },
    notVinConfirmedText: {
      margin: '0 0 0 8px',
      fontWeight: 'bold',
    },
    lastPeriodicMaintenanceInfo: {
      padding: 16,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: 'rgba(39, 187, 255, 0.2)',
      borderRadius: 4,
      margin: '8px 16px',
    },
    lastPeriodicMaintenanceIcon: {
      height: 32,
      width: 32,
      opacity: 0.9,
    },
    lastPeriodicMaintenanceText: {
      margin: '0 0 0 12px',
      fontWeight: 'bold',
      fontSize: 14,
      color: '#FFF',
    },
    expiredApiKeyContainer: {
      backgroundColor: '#e74c3c',
      width: '100%',
      padding: 16,
      height: 100,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      marginBottom: 16,
      borderRadius: 4,
    },
    expiredApiKeyText: {
      color: '#FFF',
      fontWeight: 'bold',
      fontSize: 14,
    },
    maintenanceContentContainer: {
      display: 'flex',
      justifyContent: 'flex-start',
      flexDirection: 'column',
      backgroundColor: 'rgba(0, 149, 218, 1)',
      minHeight: 500,
      width: '75%',
    },
    topInfoContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'row',
    },
    tasksAndPartsContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'row',
    },
    taskContainer: {
      width: '50%',
      borderRight: '1px solid rgba(255, 255, 255, .4)',
    },
    partContainer: {
      width: '50%',
    },
    boxContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: 16,
    },
    boxRightContainer: {
      display: 'flex',
    },
    boxLeftContainer: {
      display: 'flex',
    },
    button: {
      width: 115,
      display: 'flex',
      height: 30,
      border: '1px solid rgba(255, 255, 255, 0.7)',
      borderRadius: 50,
      alignItems: 'center',
      paddingLeft: 5,
      cursor: 'pointer',
    },
    wideButton: {
      width: 130,
      display: 'flex',
      height: 30,
      border: '1px solid rgba(255, 255, 255, 0.7)',
      borderRadius: 50,
      alignItems: 'center',
      paddingLeft: 5,
      cursor: 'pointer',
    },
    buttonRight: {
      width: 130,
      display: 'flex',
      height: 30,
      border: '1px solid rgba(255, 255, 255, 0.7)',
      borderRadius: 50,
      alignItems: 'center',
      paddingLeft: 5,
      marginLeft: 10,
      cursor: 'pointer',
    },
    buttonLeft: {
      width: 115,
      display: 'flex',
      height: 30,
      border: '1px solid rgba(255, 255, 255, 0.7)',
      borderRadius: 50,
      alignItems: 'center',
      paddingLeft: 5,
      marginRight: 10,
      cursor: 'pointer',
    },
    buttonGreen: {
      backgroundColor: '#00F600',
      border: '0 solid white',
    },
    buttonText: {
      color: 'white',
      fontSize: 14,
      textDecoration: 'none solid rgb(255, 255, 255)',
      marginLeft: 10,
    },
    buttonIcon: {
      height: 24,
      width: 24,
      marginLeft: 3,
    },
    imageContainer: {
      padding: 16,
      display: 'flex',
      flexWrap: 'wrap',
      marginTop: 50,
    },
    squareImage: {
      width: 100,
      height: 100,
      margin: '0 10px 10px 0',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      position: 'relative',
      cursor: 'pointer',
    },
    imageRemoveIcon: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      margin: 'auto',
      filter: 'drop-shadow(0px 1px 4px rgba(0,0,0,0.5))',
    },
    source: {
      fontFamily: 'TitilliumWeb-Regular',
      padding: 16,
      color: 'white',
    },
    buttonDisabled: {
      opacity: 0.5,
      cursor: 'default',
    },
  },
  medium: {
    topInfoContainer: {
      width: '100%',
    },
  },
  small: {
    topInfoContainer: {
      display: 'flex',
      justifyContent: 'normal',
      flexDirection: 'column',
      backgroundColor: 'rgba(0, 149, 218, 0.4)',
      marginLeft: 0,
      marginRight: 0,
    },
    maintenanceContentContainer: {
      display: 'flex',
      justifyContent: 'flex-start',
      flexDirection: 'column',
      backgroundColor: 'transparent',
      minHeight: 500,
      width: '100%',
      padding: 0,
    },
    bodyContainer: {
      backgroundColor: 'rgba(0, 149, 218, 1)',
      padding: 0,
    },
    tasksAndPartsContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'column',
    },
    taskContainer: {
      width: '100%',
      padding: 0,
      borderRight: 0,
    },
    partContainer: {
      width: '100%',
      padding: 0,
    },
    source: {
      backgroundColor: 'rgba(0, 149, 218, 1)',
      padding: 16,
    },
    notVinConfirmedContainer: {
      backgroundColor: 'rgba(0, 149, 218, 1)',
      padding: 16,
    }
  },
};

var chainAnalysisStyles = {
  container: {
    padding: 16,
    borderTop: '1px solid rgba(255, 255, 255, 0.4)',
  },
  statsRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: 24,
    flexWrap: 'wrap',
  },
  statItem: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 100,
  },
  statLabel: {
    color: 'rgba(255, 255, 255, 0.7)',
    fontSize: 12,
    margin: '0 0 4px 0',
  },
  statValue: {
    color: '#FFF',
    fontSize: 16,
    fontWeight: 600,
    margin: 0,
  },
  statCount: {
    color: 'rgba(255, 255, 255, 0.5)',
    fontSize: 12,
    margin: '2px 0 0 0',
  },
  percentageValue: {
    fontSize: 24,
    fontWeight: 'bold',
    margin: 0,
  },
};

function mapStateToProps(state) {
  return {
    vehicleRequest: state.vehicle,
    searchRequest: state.search,
    user: state.authUser.user,
    selectedWorkshopId: state.workshop.selectedWorkshop,
    selectedChainId: state.chain.selectedChainId,
    service: state.app.service,
  };
}

export default connect(
  mapStateToProps,
  {
    fetchVehicleMaintenance: _fetchVehicleMaintenance,
    updateVehicleMaintenance: _updateVehicleMaintenance,
    deleteVehicleMaintenance: _deleteVehicleMaintenance,
    createMaintenanceImage: _createMaintenanceImage,
    deleteMaintenanceImage: _deleteMaintenanceImage,
    checkManufacturerServiceBook: _checkManufacturerServiceBook,
  },
)(translate('VehicleDetailsView')(VehicleDetailsMaintenanceContent));
